import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import memoizeLocationQuery from '../../helpers/memoizeLocationQuery';
import {
  selectFlightResult,
  fetchFlightMatrixes,
  addFlightsFromResultToCart,
  fetchFlightSearchResults,
  fetchAirportDetails,
  fetchAirlineInformations,
  fetchFlightSearchParams,
  fetchAircraftType,
  resetExchangeQuoteStatus,
} from '../../actions/flight';
import MatrixComponent from './Matrix';

const mapStateToProps = (state, ownProps) => {
  const { searchId } = ownProps.match.params;
  const searchParams = state.flights.searchParamsBySearchId[searchId];
  const lastSearchParams = state.flights.searchParamsBySearchId.lastSearch;
  const currentSearchParams = searchParams || lastSearchParams;

  const props = {
    selectedResults: state.flights.selectedResults,
    matrixesByType: state.flights.matrixesBySearchId[searchId],
    airports: state.common.airports,
    exchangeQuote: state.flights.currentExchangeQuote,
    exchangeQuoteStatus: state.flights.exchangeQuoteStatus,
    airlineInformations: state.flights.airlineInformations,
    aircraftInformation: state.flights.aircraftTypes,
    fetchingFlightMatrices: state.flights.fetchingFlightMatrices,
    isFetchingMatrices: state.flights.isFetchingMatrices,
    tabKeyWithSelectedFareOption: state.flights.tabKeyWithSelectedFareOption,
    people: state.common.people,
    pastJourneyElementTrips:
      state.common.journeyElements.flight[ownProps.exchange.journeyElementId]?.trips,
    cartId: state.common.cart.id,
  };

  if (currentSearchParams && Object.keys(currentSearchParams).length > 0) {
    const { adults, children, infants, totalTravelerCount } = currentSearchParams;
    props.people = { adults, children, infants };
    props.totalTravelerCount = totalTravelerCount;
  } else {
    props.people = { adults: 1, children: 0, infants: 0 };
    props.totalTravelerCount = 1;
  }

  props.trips = searchParams?.trips || lastSearchParams?.trips || [];

  return props;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  selectResult: (searchId, matrix, result, tabKeyOfSelectedFairOption) =>
    dispatch(selectFlightResult(searchId, matrix, result, tabKeyOfSelectedFairOption)),
  addSelectedFlightsToCart: (justification, unchangedTripIds = []) => {
    const locationQuery = memoizeLocationQuery(ownProps.location.search);

    return dispatch(
      addFlightsFromResultToCart(
        ownProps.match.params.searchId,
        locationQuery.deal,
        locationQuery.dealGroup,
        ownProps.callbackParams,
        justification,
        ownProps.exchange.canExchange,
        ownProps.exchange.reservationItemIdentifier,
        unchangedTripIds,
      ),
    );
  },
  fetchAirportDetails: code => dispatch(fetchAirportDetails(code)),
  fetchAirlineInformations: code => dispatch(fetchAirlineInformations(code)),
  fetchAircraftType: code => dispatch(fetchAircraftType(code)),
  fetchMatrixes: (searchId, flightGroups, selectedResults, canExchange) =>
    dispatch(fetchFlightMatrixes({ searchId, flightGroups, selectedResults, canExchange })),
  fetchResults: (searchId, tripId) => dispatch(fetchFlightSearchResults({ searchId, tripId })),
  fetchSearchParams: searchId => dispatch(fetchFlightSearchParams({ searchId })),
  resetExchangeQuoteStatus: () => dispatch(resetExchangeQuoteStatus()),
});

const ConnectedMatrix = connect(mapStateToProps, mapDispatchToProps)(MatrixComponent);

const MatrixWithContext = (props, context) => <ConnectedMatrix {...props} {...context} />;

MatrixWithContext.contextTypes = {
  currency: PropTypes.string.isRequired,
  callbackParams: PropTypes.shape({}).isRequired,
  exchange: PropTypes.shape({ bookingIdentifier: PropTypes.string }).isRequired,
  laymanMode: PropTypes.bool.isRequired,
};

export default MatrixWithContext;
